import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { SpecType, SubType, InfoText, fireStatusUpdate, sendRioEvent, StatusTypes, Component, Namespace, UserAddressCommandNames } from '@chegg/commerce-utils';
import { updatedCountry, updatedZipcode, setProgressFlags } from './UserAddressState.slice';
import { fireCallbackLoggingEvent } from '../../utils/CallbackUtil';
import { sendNewRelicError } from '../../utils/NewRelicUtils';
import { ADDRESS_VALIDATION_ERRORS, ERRORS, AUTH_FAILURE_ERRORS, InlineError } from '../../constants/Errors';
import { strings } from '../../constants/strings';
export var handleAddressValidationError = function handleAddressValidationError(_ref) {
  var error = _ref.error,
    value = _ref.value,
    countryCode = _ref.countryCode,
    dispatch = _ref.dispatch;
  var code = error.code;
  if (code === ADDRESS_VALIDATION_ERRORS.SMARTY_STREETS_API_ERROR.code || code === ADDRESS_VALIDATION_ERRORS.SMARTY_STREETS_KEYS_ERROR.code || code === ADDRESS_VALIDATION_ERRORS.UNKNOWN_ERROR.code || code === ADDRESS_VALIDATION_ERRORS.MISSING_PARAMS.code || code === ADDRESS_VALIDATION_ERRORS.ZIPCODE_NOT_FOUND.code) {
    // no error message is being shown on invalid response because regex is matching
    dispatch(updatedZipcode({
      invalid: ''
    }));
    sendNewRelicError("Invalid zipcode from smartystreet Error: zipcode: ".concat(value, ", country: ").concat(countryCode));
  } else if (code === ADDRESS_VALIDATION_ERRORS.INCORRECT_COUNTRY_CODE.code) {
    dispatch(updatedCountry({
      countryCode: '',
      countryName: '',
      error: true
    }));
    fireStatusUpdate([{
      status: StatusTypes.ERROR,
      command: UserAddressCommandNames.VERIFY_ADDRESS,
      payload: {
        component: Component.COUNTRY_SELECTED,
        errors: [error]
      }
    }], Namespace.USER_ADDRESS);
  } else {
    sendNewRelicError("Unknown Address Validation Error Type : ".concat(JSON.stringify(error)));
  }
};

// Invalid zipcode error handler if regex is not matching
export var handleInvalidZipcodeError = function handleInvalidZipcodeError(dispatch) {
  dispatch(updatedZipcode({
    invalid: strings['APP.ZIPCODE.ERROR.INVALID']
  }));
  sendRioEvent({
    info: InfoText.ZIP_ERROR,
    message_detail: InlineError.INVALID,
    specType: SpecType.NOTIFICATION,
    subType: SubType.ERROR,
    callback: function callback(logObj) {
      return fireCallbackLoggingEvent(logObj);
    },
    namespace: Namespace.USER_ADDRESS
  });
  fireStatusUpdate([{
    status: StatusTypes.ERROR,
    command: UserAddressCommandNames.VERIFY_ADDRESS,
    payload: {
      component: Component.ZIPCODE,
      errors: [_objectSpread(_objectSpread({}, ERRORS.INLINE_ERRORS), {}, {
        message: strings['APP.ZIPCODE.ERROR.INVALID']
      })]
    }
  }], Namespace.USER_ADDRESS);
};
export var sendErrorCallbacksToHost = function sendErrorCallbacksToHost(errors) {
  for (var i = 0; i < errors.length; i++) {
    var error = errors[i];
    if (error.code === AUTH_FAILURE_ERRORS.AUTH_FAILURE) {
      fireStatusUpdate([{
        status: StatusTypes.ERROR,
        command: UserAddressCommandNames.VERIFY_ADDRESS,
        payload: {
          errors: [error]
        }
      }], Namespace.USER_ADDRESS);
    }
  }
};
export var sendProgressStatusCallbacksToHost = function sendProgressStatusCallbacksToHost(data, response, zipcode) {
  var addressFetchCompleted = !data.showFetchProgress;
  fireStatusUpdate([{
    status: StatusTypes.SUCCESS,
    command: UserAddressCommandNames.UA_PROGRESS_STATUS,
    payload: {
      component: Component.ZIPCODE,
      data: {
        addressFetchCompleted: addressFetchCompleted,
        response: response,
        zipcode: zipcode
      }
    }
  }], Namespace.USER_ADDRESS);
};
export var Timer = /*#__PURE__*/function () {
  function Timer(dispatch) {
    _classCallCheck(this, Timer);
    _defineProperty(this, "time", 3000);
    _defineProperty(this, "dispatch", void 0);
    this.dispatch = dispatch;
  }
  return _createClass(Timer, [{
    key: "showProgress",
    value: function () {
      var _showProgress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action, response, zipcode) {
        var showFetchProgressFlag, _showFetchProgressFlag;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(action === 'start')) {
                _context.next = 6;
                break;
              }
              // start timer - show the progress indicator and send the true flag to host
              showFetchProgressFlag = {
                showFetchProgress: true
              };
              this.dispatch(setProgressFlags(showFetchProgressFlag));
              sendProgressStatusCallbacksToHost(showFetchProgressFlag, response, zipcode);
              _context.next = 15;
              break;
            case 6:
              if (!(action === 'stop')) {
                _context.next = 10;
                break;
              }
              // stop timer - hide the progress indicator and send the false flag to host
              this.reset(action, response, zipcode);
              _context.next = 15;
              break;
            case 10:
              // app/api error - start timer, show progress indicator.
              // after timer has expired, hide progress indicator and send the false flag to host.
              _showFetchProgressFlag = {
                showFetchProgress: true
              };
              this.dispatch(setProgressFlags(_showFetchProgressFlag));
              _context.next = 14;
              return this.timeout();
            case 14:
              // implement this way to work around a settimeout not working problem.
              this.reset('timer', response, zipcode);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function showProgress(_x, _x2, _x3) {
        return _showProgress.apply(this, arguments);
      }
      return showProgress;
    }() // reset timer, hide the progress indicator, send the false flag to host.
  }, {
    key: "reset",
    value: function reset(_, response, zipcode) {
      var showFetchProgressFlag = {
        showFetchProgress: false
      };
      this.dispatch(setProgressFlags(showFetchProgressFlag));
      sendProgressStatusCallbacksToHost(showFetchProgressFlag, response, zipcode);
    }
  }, {
    key: "timeout",
    value: function timeout() {
      var _this = this;
      return new Promise(function (resolve) {
        return setTimeout(resolve, _this.time);
      });
    }
  }]);
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/redux/UserAddressState/UserAddressState.helpers.js
// module id = 4498
// module chunks = 11